import { Button } from '@superdispatch/ui';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { animated, useSpring } from 'react-spring';
import styled, { css } from 'styled-components';
import ArrowForwardIcon from './shared/assets/arrow-forward.svg?react';
import CheckIcon from './shared/assets/ic-check.svg?react';
import { trackPage } from './shared/helpers/AnalyticsHelpers';
import { Header } from './shared/layout/Header';

const Wrapper = styled.div`
  min-height: 100vh;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: 1fr 1fr;
  grid-auto-flow: column;
  column-gap: 50px;
  position: relative;
  z-index: 99;
  padding: 120px 14vw;
  align-items: baseline;
  justify-content: center;
  & > *:nth-child(2) {
    margin-bottom: 50px;
  }
  @media (max-width: 1196px) {
    padding: 120px 10vw;
  }
  @media (max-width: 1024px) {
    grid-auto-flow: row;
    grid-template-columns: auto;
    grid-template-rows: auto;
    padding: 55px 32px;
    align-items: center;
  }
`;
const BackgroundShape = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 20%;
  background-color: #f3f5f8;
  &::before {
    border-top: 229px solid white;
    border-right: 100vw solid transparent;
    content: '';
    height: 0;
    left: 0;
    position: absolute;
    width: 0;
  }
`;
const ProductCard = styled.div<{ patternPosition?: 'right' | 'left' }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 568px;
  background: #ffffff;
  border: 1px solid #e1e5ea;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 32px;
  position: relative;
  text-align: center;
  width: 100%;
  &::before {
    content: ' ';
    background-image: url(data:image/svg+xml;base64,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);
    position: absolute;
    width: 100%;
    height: 50%;
    z-index: -1;
    top: -40px;
    right: -40px;
    @media (max-width: 1024px) {
      right: -27px;
      top: -27px;
    }
    background-repeat: no-repeat;
    background-position: top right;
    ${({ patternPosition }) =>
      patternPosition === 'left' &&
      css`
        left: -40px;
        background-position: unset;
        @media (max-width: 1024px) {
          left: -27px;
        }
      `};
  }
`;
const ProductCardTitle = styled.div`
  font-size: 48px;
  line-height: 54px;
  text-align: center;
  letter-spacing: 0.35px;
  font-weight: 600;
  @media (max-width: 768px) {
    font-size: 28px;
  }
`;
const ProductCardDescription = styled.div`
  flex-grow: 1;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  letter-spacing: 0.35px;
  margin-top: 16px;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: 32px;
  color: #6a707c;
  font-weight: 400;
  min-height: 56px;
  @media (max-width: 1368px) {
    font-size: 16px;
  }
`;
const LargeButton = styled(Button)`
  .MuiButtonBase-root {
    height: 68px !important;
  }

  && {
    padding: 16px 48px;
    @media (max-width: 768px) {
      padding: 16px;
      width: 100%;
    }
  }
  & > span {
    font-size: 24px;
    line-height: 36px;
    white-space: nowrap;
    display: flex;
    letter-spacing: 0.35px;
    position: relative;
    top: -2px;
    & > svg {
      position: relative;
      top: 2px;
    }
  }
`;
const Features = styled.div`
  margin: 20px 0;
  max-width: 568px;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
`;
const FeatureItem = styled.span`
  font-size: 14px;
  margin: 5px 0;
  line-height: 20px;
  letter-spacing: 0.35px;
  color: #6a707c;
  white-space: nowrap;
  font-weight: 500;
  display: flex;
  & > * {
    margin-right: 8px;
  }
  &:not(:last-child) {
    margin-right: 16px;
  }
`;
const StyledLink = styled(Link)`
  text-decoration: none;
  &:focus,
  &:active,
  &:hover,
  &:visited {
    text-decoration: none;
  }
`;
const StyledArrowForwardIcon = styled(ArrowForwardIcon)`
  margin-left: 10px;
`;

export const SelectProduct = () => {
  const location = useLocation();
  const fadeIn = useSpring({ from: { opacity: 0 }, to: { opacity: 1 } });

  useEffect(() => {
    document.title = 'Sign Up';
    trackPage('Sign Up');
  }, []);

  return (
    <animated.div style={fadeIn}>
      <Wrapper>
        <Header type="main" />
        <Content>
          <ProductCard patternPosition="left">
            <ProductCardTitle>For Carriers</ProductCardTitle>
            <ProductCardDescription>
              The auto transport platform built with everything a Carrier needs
              to manage operations easier and move cars faster, all-in-one.
            </ProductCardDescription>
            <StyledLink
              to={{
                pathname: '/carrier/create-account',
                search: location.search,
              }}
            >
              <LargeButton variant="contained">
                Sign Up <StyledArrowForwardIcon />
              </LargeButton>
            </StyledLink>
          </ProductCard>
          <Features>
            <FeatureItem>
              <CheckIcon />7 day free trial
            </FeatureItem>
            <FeatureItem>
              <CheckIcon />
              No credit card required
            </FeatureItem>
            <FeatureItem>
              <CheckIcon />
              Cancel anytime
            </FeatureItem>
          </Features>

          <ProductCard>
            <ProductCardTitle>For Shippers and Brokers</ProductCardTitle>
            <ProductCardDescription>
              The all-in-one platform for Shippers and Brokers to elevate their
              business with streamlined workflows, instant tracking updates, and
              simplified operations.
            </ProductCardDescription>
            <StyledLink to={{ pathname: '/shipper', search: location.search }}>
              <LargeButton variant="contained">
                Request Access <StyledArrowForwardIcon />
              </LargeButton>
            </StyledLink>
          </ProductCard>
          <Features>
            <FeatureItem>
              <CheckIcon />
              30-day money back guarantee
            </FeatureItem>
          </Features>
        </Content>
        <BackgroundShape />
      </Wrapper>
    </animated.div>
  );
};
